import Container from '@modules/common/components/container';

/**
 * Skeleton shown during lazy loading of HomePage component.
 * Note: Data loading skeletons are now handled within each section component.
 */
export function HomePageSkeleton() {
  return (
    <>
      {/* Hero Carousel Skeleton */}
      <div className="mx-auto mb-6 md:my-6 md:max-w-[1440px] md:px-6">
        <div className="bg-grey-5 h-[120px] animate-pulse sm:h-[250px] md:h-[400px] md:rounded-md" />
      </div>

      {/* Banners Skeleton */}
      <Container className="mb-12">
        <div className="mt-4 grid grid-cols-2 gap-4">
          {[1, 2].map((i) => (
            <div
              key={i}
              className="bg-grey-5 aspect-[16/9] animate-pulse rounded-md"
            />
          ))}
        </div>
      </Container>

      {/* Latest News Skeleton */}
      <Container as="section" className="mb-20 mt-10 w-full px-0 md:px-8">
        <div className="mx-auto w-full max-w-[900px] px-4 md:px-8">
          <div className="flex justify-center">
            <div className="bg-grey-5 h-8 w-32 animate-pulse rounded" />
          </div>
          <div className="mt-4 rounded-xl border p-8 md:mt-12">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center justify-between py-4">
                <div className="flex-1">
                  <div className="bg-grey-5 mb-2 h-5 w-3/4 animate-pulse rounded" />
                  <div className="bg-grey-5 h-4 w-1/3 animate-pulse rounded" />
                </div>
                <div className="bg-grey-5 h-6 w-6 animate-pulse rounded" />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </>
  );
}
